export default "__VITE_ASSET__C$CXB9OY__"